import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

const TextSlider = () => {
  const { slider, data: sliderData, loadingSlider, errorSlider } = useSelector((state) => state.slider);
  
  const offerStripSliders = sliderData?.filter(slide => 
    slide.position === "offer_strip" && slide.status === "active"
  ) || [];
  
  const displaySliders = offerStripSliders.length > 0 
    && offerStripSliders 
   
  if (loadingSlider) {
    return (
      <div className="text-slider-sec">
              <span className="visually-hidden">Loading...</span>
      </div>
    );
  }

  if (errorSlider) {
    console.error("Error loading sliders:", errorSlider);
  }

  return (
    <div className="text-slider-sec">
      <div className="container big-container">
        {displaySliders.length > 0 && (
          <div id="textCarousel" className="carousel slide" data-bs-ride="carousel" data-bs-interval="4000">
            <div className="carousel-inner">
              {displaySliders.map((slide, index) => (
                <div 
                  key={slide.id || index} 
                  className={`carousel-item ${index === 0 ? 'active' : ''}`}
                >
                  <div className="advertise-slider-item text-center">
                    <p className="mb-0">{slide.title}</p>
                  </div>
                </div>
              ))}
            </div>

            {displaySliders.length > 1 && (
              <>
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#textCarousel"
                  data-bs-slide="prev"
                >
                  <img src="/image/angle-left.svg" alt="Previous" />
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#textCarousel"
                  data-bs-slide="next"
                >
                  <img src="/image/angle-right.svg" alt="Next" />
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TextSlider;